import React, { SVGProps } from 'react';
import { color } from 'utils/colors';

interface Props extends SVGProps<SVGSVGElement> {
  active?: boolean;
}

export const SingleCamIcon: React.FC<Props> = ({ active, ...svgProps }) => (
  <svg width={20} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...svgProps}>
    <path fill={active ? color('white') : '#424242'} d="M0 0h20v14H0z" />
  </svg>
);

export const MultiCamIcon: React.FC<Props> = ({ active, ...svgProps }) => {
  const fill = active ? color('white') : '#424242';

  return (
    <svg
      width="21"
      height="15"
      viewBox="0 0 21 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <rect width="10" height="7" fill={fill} />
      <rect x="11" width="10" height="7" fill={fill} />
      <rect x="11" y="8" width="10" height="7" fill={fill} />
      <rect y="8" width="10" height="7" fill={fill} />
    </svg>
  );
};
